import { IconCross } from '@/icons/IconCross';
import IComponentProps from '@/interfaces/componentProps';
import { Transition } from '@headlessui/react';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Modal = ({
  open,
  heading,
  className = `w-[50rem] ${heading ? '' : 'px-2 py-3'}`,
  closeModal,
  children,
  closeButton = true,
  changeHeight = true,
  contentClass,
  adPopUp = false,
}: {
  open: boolean;
  heading?: string;
  closeModal: () => void;
  closeButton?: boolean;
  changeHeight?: boolean;
  contentClass?: string;
  adPopUp?: boolean;
} & IComponentProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  return mounted ? (
    createPortal(
      <>
        <Transition show={open}>
          <div className={`fixed inset-0 z-[102] flex h-full  w-full bg-transparent`} onClick={closeModal}>
            <Transition.Child
              appear={true}
              className="absolute inset-0 flex h-full w-full bg-black bg-opacity-20"
              enter="transition-opacity duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-all duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            ></Transition.Child>
            <Transition.Child
              className={`relative z-[101] m-auto min-w-[90%] max-w-[1123px] p-8 md:min-w-[400px] ${contentClass}`}
              enter="transition-all duration-300"
              enterFrom="max-xs:translate-y-full xs:scale-0"
              enterTo="max-xs:translate-y-0 xs:scale-100"
              leave="transition-all duration-300"
              leaveFrom="max-xs:translate-y-0 xs:scale-100"
              leaveTo="max-xs:translate-y-full xs:scale-0"
            >
              <div
                onClick={(event: any) => event.stopPropagation()}
                className={`modal-dialog w-full  overflow-hidden rounded-xl  bg-white ${!adPopUp && 'pb-8 xs:pb-4'} `}
                style={{ boxShadow: '0px 0px 20px rgb(0 0 0 / 50%)' }}
              >
                <div className={`relative flex max-h-[90vh] flex-col rounded-[inherit] ${className}`}>
                  {(heading || closeButton) && (
                    <div className={`modal-heading flex text-lg ${heading ? 'relative border-b' : ''}`}>
                      {heading && <h4 className="flex-grow py-5 pr-20 pl-8 font-semibold leading-none">{heading}</h4>}
                      {closeButton && (
                        <span className={`absolute top-0 ${adPopUp && 'rounded-full bg-white shadow-lg'} right-0 z-[1000000] ml-auto`}>
                          <IconCross onClick={closeModal} className={`w-8 cursor-pointer  p-1.5 ${heading ? 'mt-4 mr-4' : 'm-1'}`} />
                        </span>
                      )}
                    </div>
                  )}
                  <div
                    className={`modal-body overflow-y-auto ${!adPopUp && 'px-8 py-6'}  text-xl`}
                    style={changeHeight ? { maxHeight: heading || closeButton ? `calc(100vh - 10rem)` : `calc(100vh - 4rem)` } : {}}
                  >
                    {children}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Transition>
      </>,
      document.getElementById('portal')!,
    )
  ) : (
    <></>
  );
};

export default Modal;
